import type { IconProps } from './types';

const ChevronDownSmIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 11, ref, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
      width={size}
      height={(size * 7) / 11}
      viewBox="0 0 11 7"
      fill="none"
    >
      <path d="M10.2417 0.397949L5.31982 5.31982L0.397949 0.397949" stroke={color} strokeWidth="1.125" />
    </svg>
  );
};

export { ChevronDownSmIcon };
